import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../../services/common/common.service";
import { GlobalContext } from "../../../store";
// import CategoriesContent from "../../../modules/settings/components/roles-management/categories-content/categories-content.component";
import CoordinatorsContent from "../../../modules/settings/components/roles-management/coordinators-content/coordinators-content.component";
import SettingsHead from "../../../modules/settings/shared/settings-head/settings-head.component";
import { Box } from "@material-ui/core";
import { UserRoles } from "../../../types/userRoles";

export default function RolesManagementPage(props: any) {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { user, setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.ROLE_MANAGEMENT"));
      setPageTitle(t("PAGE_META_TITLES.ROLE_MANAGEMENT"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="content">
      <SettingsHead
        title={t("PAGES_HEAD.SETTINGS.ROLE_MANAGEMENT_TITLE")}
        subTitle={t("PAGES_HEAD.SETTINGS.ROLE_MANAGEMENT_SUB_TITLE")}
      />
      {/* {(user.role === UserRoles.SUPER_ADMIN ||
            (user.type === "superUser" && user.role === "coordinator")) && (
            <CategoriesContent />
          )} */}
      {(user.role === UserRoles.SUPER_ADMIN ||
        user.role === UserRoles.COORDINATOR) && <CoordinatorsContent />}
    </Box>
  );
}
